<template>
    <div class="body fixed mobile">
        <!-- class: fixed, mobile -->
        <!-- Loading Spinner -->
        <!-- <div class="spinner"><div><div></div></div></div> -->
        <!-- Header -->
        <section class="header notice">
            <div class="flexH width">
                <a class="icon iconButton third" @click.prevent="$router.push('/home')">
                    <font-awesome-icon icon="fa-solid fa-chevron-left" size="lg"></font-awesome-icon>
                </a>
            </div>
            <span class="fL nowrap">通知中心</span>
            <div class="flexH width right"  @click.prevent="$router.push('/notification-setting')" >
                <!-- NOTE: Howard's fix: 暫時隱藏全部已讀功能 -->
                <img src="@/assets/icon/setting-v2.svg"  />
                            
            </div>
        </section>
        <!-- Main -->
        <section class="main notice">
            <!-- Filter -->
            <div class="filter flexH width bg-white justify-between board-pad-2" style="width:97%;">
                <div class="flexH  middle">
                    <div class="dropdown button border-button rounded board-pad-3 min-h-init ">
                        <select v-model="readType" name="type" class="fS rounded h-auto">
                            <option value="">全部通知</option>
                            <option value="unread">未讀通知</option>
                        </select>
                        <div class="arrow third primary">
                            <font-awesome-icon icon="fas fa-caret-down" size="xs"></font-awesome-icon>
                        </div>
                    </div>
                </div>
                <!-- <div class="lineV"></div> -->
                <div class="flexH  middle">
                    <div class="dropdown button border-button rounded board-pad-3 min-h-init ">
                        <select v-model="period" name="type" class="fS rounded h-auto">
                            <option value="">不限時間</option>
                            <option value="week">近一週</option>
                        </select>
                        <div class="arrow third ">
                            <font-awesome-icon icon="fas fa-caret-down primary" size="xs"></font-awesome-icon>
                        </div>
                    </div>
                </div>
                <a class="textButton fS primary" @click.prevent="readAll()">全部已讀</a>
            </div>
            <!-- <div class="notify">
                <span>文章通知</span>
                <label class="switch">
                    <input type="checkbox" checked>
                    <span class="slider round"></span>
                </label>
            </div> -->
            <!-- 紀錄 -->
            <div class="records flexV width padding">
                <div
                    v-for="(notification, index) in notifications"
                    :key="'notification' + index"
                >
                    <a
                        class="record flexH width margin relative board-pad"
                        @click.stop="readItem(notification.id)"
                    >
                      
                        <div class="flexV width gap-1">
                            <span class="fS font-normal primary">{{ getNotifyTypeName(notification.subtype || notification.subType) }}</span>
                            <span class="fL font-normal cNeutral900" v-html="notification.text"></span>
                            <span class="fS font-normal cNeutra500">{{
                                tsToDatetime(notification.ts)
                            }}</span>
                        </div>
                        <!-- <div class="img">
                            <img src="@/assets/icon/point.svg" />
                        </div> -->
                        <img v-if="notification.unread" src="@/assets/icon/bell-v2.svg"
                            :class="['absolute','top-n8','left-n8', { display: notification.unread?'block':'hidden' }]"
                        />
                        <!-- <font-awesome-icon :icon="['fas', 'chevron-right']" color="#6B2DF5" /> -->
                    </a>
                    <div class="lineH"></div>
                </div>
                <div
                    class="text-center py-4"
                    v-if="(!notifications || notifications.length == 0)  == true"                    
                >
                    <img  width="160" height="160" src="@/assets/icon/empty-notification.svg" />
                   <div class="fL font-medium  cNeutral500 text-center">很抱歉，目前無通知紀錄</div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { db } from "../db.js";
import moment from "moment-timezone";
import { mapState } from "vuex";

export default {
    name: "",
    data() {
        return {
            // notifications: [],
            latestReadAt: 0,
            readType: "",
            period: ''
        };
    },
    beforeRouteEnter(to, from, next) {
        // called before the route that renders this component is confirmed.
        // does NOT have access to `this` component instance,
        // because it has not been created yet when this guard is called!
        console.log(to, from);
        next((vm) => {
            let that = vm;
            if (that.user && that.user.userId) {
                //
            } else {
                // window.location.reload();
                next("/home");
            }
        });
    },
    mounted() {
        console.log("mounted!");
        this.$store.dispatch('noti/init')
        // this.onSnapShot();

        //NOTE: Howard's fix: 現在notification直接從store取用，不用再原地去Firestore撈了
        // this.getLatestReadTime()
        // .then(() => {
        //     this.onSnapShot();
        // });

        setTimeout(() => {
            console.log('Notifications', this.notifications);
        }, 4000)
    },
    computed: {
        ...mapState(["user", "userInfo"]),
        // ...mapGetters({
        //     notifications: 'noti/notifications'
        // }),
        notifications() {
            let ns = this.$store.getters['noti/notifications'];
            // fake data
            // ns = [{id:1,title:"title1",text:"text1",ts:1720961906,unread:true},{id:2,title:"title2",text:"text2",ts:1720961906,unread:true}];
            let res = Object.values(ns)
            console.log('qqqq', new Date().getTime() - 604800000)
            if (this.period == 'week') {
                res = res.filter(n => n.ts > (new Date().getTime() - 604800000) / 1000)
            }
            if (this.readType === 'unread') {
                res = res.filter(n => n.unread)
            }
            return res.sort((a, b) => {
                return b.ts - a.ts;
            });
        }
    },
    methods: {
        getNotifyTypeName(type) {
            const m = {
                poclicy: '政令通知',
                activity: '活動通知',
                "points-reward": '雲林幣歸戶通知',
                useCoin: '雲林幣使用通知',
                system: '系統通知'
            }
            return m[type]
        },
        compare(a, b) {
            if (a.ts > b.ts) {
                return -1;
            } else if (a.ts == b.ts) {
                return 0;
            } else if (a.ts < b.ts) {
                return 1;
            }
        },
        goBack() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push("/");
        },
        tsToDatetime(ts) {
            return moment(ts * 1000).format("YYYY-MM-DD HH:mm:ss");
        },
        onSnapShot() {
            let collection = db.collection(
                `notifications/yulin/topics/${this.user.user.firestoreChannelId}/messages`
            );
            // doesn't use change to vuefire bind
            collection.onSnapshot((snapshot) => {
                this.notifications = [];
                snapshot.forEach((doc) => {
                    const data = doc.data();
                    this.notifications.push(
                        Object.assign({}, data, { docId: doc.id, unread: data.unread && (data.ts > this.latestReadAt) })
                    );
                });
                this.notifications.sort(this.compare);
                console.log("this.notifications: ", this.notifications)
                this.getLatestReadTime();
            });
        },
        getLatestReadTime() {
            return db.collection(`notifications/yulin/recipients/${this.user['userId']}/readTopics`)
            .doc(this.user.user.firestoreChannelId)
            .get()
            .then(snapshot => {
                if (!snapshot.exists) return;
                this.latestReadAt = snapshot.data().latestReadAt;
            });
        },
        updateUnreads(_latestReadAt) {
            if (_latestReadAt)
                this.latestReadAt = _latestReadAt;
            this.notifications.forEach(noti => {
                if (noti.ts <= this.latestReadAt)
                    noti.unread = false;
            });
        },
        readItem(docId) {
            // let collection = db.collection(
            //     `notifications/yulin/topics/${this.user.user.firestoreChannelId}/messages`
            // );
            // let document = collection.doc(docId);
            // return db.runTransaction((transaction) => {
            //     return transaction.get(document).then((doc) => {
            //         transaction.update(document, {
            //             unread: false
            //         });
            //         return doc;
            //     });
            // });
            //NOTE: Howard's fix: use API to mark read instead of writing Firestore directly.
            let config = {
                url: `${process.env.VUE_APP_API_HOST}/notifications/v1/merchants/${process.env.VUE_APP_MERCHANT_ID}/firestore-mark-read`,
                method: 'POST',
                data: {
                    member_id: this.userInfo.memberId,
                    uuid: this.user.uuid,
                    message_id: docId
                }
            }
            return this.$http(config);
        },
        readAll() {
            // let collection = db.collection(
            //     `notifications/yulin/topics/${this.user.user.firestoreChannelId}/messages`
            // );
            // let batch = db.batch();
            // collection
            //     .get()
            //     .then((querySnapshot) => {
            //         querySnapshot.forEach((doc) => {
            //             let docRef = collection.doc(doc.id);
            //             batch.update(docRef, {unread: false});
            //         });
            //         batch.commit()
            //             .then(() => {
            //                 console.log("Read All!");
            //             })
            //     })
            //     .catch((error) => {
            //         console.log("Error getting documents: ", error);
            //     });
            //NOTE: Howard's fix: use API to mark all read instead of writing Firestore directly.
            console.log('this.user', this.user)
            let config = {
                url: `${process.env.VUE_APP_API_HOST}/notifications/v1/merchants/yunlin/firestore-mark-topic-read`,
                method: 'POST',
                data: {
                    topicId: this.user.user.firestoreChannelId,
                    member_id: this.userInfo.memberId,
                    uuid: this.user['userId']
                }
            }
            this.updateUnreads(moment().unix());//Manually mark all current notifications "read".
            this.$store.commit('noti/setUnreadCount', 0);
            return this.$http(config);
        }
    }
};
</script>

